module.exports = __webpack_public_path__ + "assets/img/1414.a1469ade.svg";